import { FilterField, labelId } from "kontrolEdge/helpers/advancedFilters";
import type { GroupRow } from "./GroupsData";

export function makeGroupsFields(): FilterField<GroupRow>[] {
  const fields: FilterField<GroupRow>[] = [
    {
      label: "Name",
      key: "name",
      accessor: (r) => r.name,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Description",
      key: "description",
      accessor: (r) => r.description ?? "",
      type: "string",
      inFreeText: true,
    },
    {
      label: "Status",
      key: "status",
      accessor: (r) => r.healthLabel,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Recipients",
      key: "recipients",
      accessor: (r) => r.memberCount ?? 0,
      type: "number",
    },
    {
      label: "Resources",
      key: "resources",
      accessor: (r) => r.assignmentCount ?? 0,
      type: "number",
    },
  ];
  for (const f of fields) f.key ??= labelId(f.label);
  return fields;
}
